module.exports = __webpack_public_path__ + "static/media/not_coach_gold.5cf27849.png";